export const meta: BlockMeta = {
  title: "Expandable",
  tags: ["subpage"],
}

import { Collapsible } from "@components/ui/Collapsible"
import { IconAdd } from "@components/ui/Icon"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/expandable", (props) => {
  return (
    <div className="w-full mt-2 mb-4">
      <InnerBlocks allowedBlocks={["content/expandable-item"]} template={[["content/expandable-item", {}]]} />
    </div>
  )
})
